import React from 'react';
import { IconBase } from '../Base';
export const IconChevronLeft = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M11.6667 6.66663L8.33334 9.99996L11.6667 13.3333", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Left.js.map